var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#DBDBDB",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(9.84615,9.84615)",
    fill: "#DBDBDB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,11.30078c2.80078,-4.19922 7.19922,-8 7.39844,-8.10156c0.10156,-0.09766 0.40234,-0.19922 0.60156,-0.19922c0.19922,0 0.5,0.10156 0.69922,0.19922c0.19922,0.10156 4.60156,4 7.40234,8.10156c0.19922,0.30078 0.19922,0.69922 0.09766,1.09766c-0.19922,0.30078 -0.5,0.60156 -0.89844,0.60156h-3.69922c0,0 -0.5,8.69922 -0.80078,9.10156c-0.5,0.5 -1.69922,0.89844 -2.80078,0.89844c-1.10156,0 -2.19922,-0.39844 -2.60156,-0.89844c-0.19922,-0.40234 -0.89844,-9.10156 -0.89844,-9.10156h-3.69922c-0.40234,0 -0.69922,-0.19922 -0.90234,-0.60156c-0.19922,-0.29687 -0.09766,-0.69922 0.10156,-1.09766z",
    fill: "#DBDBDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageUp);
export default __webpack_public_path__ + "static/media/PageUp.5b750c5d6b51d677c6c36af2a5cf7d7e.svg";
export { ForwardRef as ReactComponent };